import Axios from 'axios'
import logger, { errorWithStack } from '@utils/logger'

const CreateLead = ({
  registrationNumber,
  phoneNo,
  sourceName = 'SEO_FASTAG',
  productKey = 'car',
  apiKey = 'f4imWcFNATEZ4F'
}) => {
  Axios.post(
    '/lead/v1/create',
    {
      phone: phoneNo,
      product: productKey,
      registration_number: registrationNumber || '',
      source: sourceName
    },
    {
      headers: {
        apiKey
      }
    }
  )
    .then(res => {
      logger.info('Create Lead Response', { res })
    })
    .catch(e => {
      errorWithStack('Error in create lead', e)
    })
}

export default CreateLead
